import styled, { css } from 'styled-components';
import { ellipsisText } from '../../../../util/style/ellipsis-text.util';
import { ColorEnum } from '../../../../enum/color.enum';
import { BlockColorType } from '../../../../enum/block-color.enum';
import { ISingleJobadItemData } from '../../../../model/linked-data';
import { JobadListModel } from '../../../../model/block';
import { JobadPinIcon, TagIcon, TimeIcon } from '../../../icons';
import { determineTextColor } from '../../../../util/style/determine-text-color';
import { largeMobileMedia } from '../../../../util/style/large-mobile-media';

export const JobadTagsWrapper = styled.div`
  display: flex;
`;

interface IJobadTagProps {
  paddingLeft?: number;
  backgroundColor: BlockColorType;
  textColor: BlockColorType;
  maxWidth?: number;
}

export const Tag = styled.div`
  background-color: ${(props: IJobadTagProps) => ColorEnum.getColor(props.backgroundColor)(props as any)};
  color: ${props => !props.textColor || props.textColor === 'Transparent' ? determineTextColor(ColorEnum.getColor('PrimaryTextColor')(props as any)) : ColorEnum.getColor(props.textColor)(props as any)};
  border-radius: 5px;
  font-size: 14px;
  padding: 3px 10px 3px ${(props: IJobadTagProps) => props.paddingLeft ? props.paddingLeft : 8}px;
  margin-right: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 0;
  max-width: ${(props: IJobadTagProps) => props.maxWidth ? props.maxWidth : 200}px;
`;

export const OnlyDesktopTag = styled(Tag)`
  ${largeMobileMedia(`
    display: none;
  `)}
`;

export const CompanyNameWrapper = styled.div`
  color: ${props => ColorEnum.getColor('PrimaryTextColor')(props as any)};
  font-size: 18px;
  ${ellipsisText}
`;

export const PositionWrapper = styled.div`
  display: block;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-clamp: 2;
  -webkit-line-clamp: 2;
  max-height: 3em;
  box-sizing: content-box;
  font-size: 21px;
  font-weight: bold;
  height: 60px;
  color: ${(props: { color: BlockColorType }) => ColorEnum.getColor(props.color)(props as any)};
  margin-bottom: 10px;
`;

const iconCSS = css`
  min-width: 24px;
  min-height: 24px;
  max-width: 24px;
  max-height: 24px;
`;

export const StyledPin = styled(JobadPinIcon)`
  ${iconCSS}
`;

export const StyledTag = styled(TagIcon)`
  ${iconCSS}
`;

export const StyledTime = styled(TimeIcon)`
  ${iconCSS}
`;

export interface IBaseJobadProps {
  jobad: JobadListModel;
  item: ISingleJobadItemData;
  applyBeforeBackgroundColor: BlockColorType;
  jobadBackgroundColor: BlockColorType;
  jobadTagBackgroundColor: BlockColorType;
  jobadTagTextColor: BlockColorType;
  linkTemplate: any;
  isInEditMode: boolean;
  hasShadow?: boolean;

  [key: string]: any;
}

export const TagText = styled.span`
  padding-left: 3px;
  ${ellipsisText};
`;
